export default "__VITE_ASSET__B$R5HEMF__"